import { StateObservable } from "redux-observable";
import { Evaluation } from "../evaluation";
import { AppState } from "../redux";

export const isEvaluatorOfEval = (evl: Evaluation, state: AppState) => {
    const authorId = evl.author;
    const evaluatorId = evl.evaluatorId;
    const evaluator2Id = evl.evaluator2Id;
    const loggedInUserId = state.session.dfdmToken?.sub;
    return !!(
        authorId === loggedInUserId ||
        (!evaluatorId || evaluatorId === loggedInUserId) ||
        (evaluator2Id && evaluator2Id === loggedInUserId)
    );
}

export const isAdmin = (state: AppState) => {
    return (state.session.dfdmToken?.profile.roles || []).includes('ROLE_ADMIN');
}